/* Classify a fabric's light behaviour from its collection / material metadata */

/* Openness → shade opacity.  Higher values = less room bleed-through = better swatch-color fidelity.
   Calibrated so the *perceived* fabric colour stays close to the original swatch while
   still letting the viewer distinguish between openness grades. */
export const OPENNESS_OPACITY = { 1: 0.98, 3: 0.94, 5: 0.88, 10: 0.76 };

const FILTER_PRESETS = [
  { match: /privacy/, label: 'Privacy', opacity: 0.93 },
  { match: /light filtering|translucent|natural weave|nature concept/, label: 'Light Filtering', opacity: 0.85 },
  { match: /semi-?sheer/, label: 'Semi-Sheer', opacity: 0.78 },
  { match: /sheer/, label: 'Sheer', opacity: 0.68 },
];

export const classifyFabric = (color, material, collection) => {
  /* Most specific openness wins: colour → material → collection */
  const openness = `${color?.openness || material?.openness || collection?.openness || ''}`.toLowerCase();
  const type = `${color?.fabric_type || ''} ${material?.fabric_type || ''} ${collection?.fabric_type || ''} ${collection?.collection_name || ''} ${color?.product_type || ''}`.toLowerCase();
  const all = `${openness} ${type}`;

  const pcts = [...openness.matchAll(/(\d+)\s*%/g)].map(m => parseInt(m[1], 10)).filter(n => n > 0);
  const isScreen = /screen|solar/.test(type) || pcts.length > 0;
  if (isScreen) {
    const options = [...new Set(pcts.filter(n => OPENNESS_OPACITY[n]))].sort((a, b) => a - b);
    return { mode: 'screen', label: 'Solar Screen', options: options.length ? options : [1, 3, 5, 10] };
  }

  if (/black-?out/.test(all) && !/light filtering|sheer/.test(openness)) {
    return { mode: 'blackout', label: 'Blackout' };
  }

  const preset = FILTER_PRESETS.find(p => p.match.test(all)) || FILTER_PRESETS[1]; // default: Light Filtering
  return { mode: 'filtering', label: preset.label, opacity: preset.opacity };
};
